import { BASE_LABELS, NAV_LABEL_KEYS } from '../constants/labels';

/**
 * Module-level label store so plain data modules (e.g. the *Columns arrays in utils.js)
 * can resolve labels without hooks. The LabelsProvider keeps it in sync with the server;
 * localStorage seeds it before the first fetch so labels paint correctly on load.
 * Column definitions should expose labels as getters (get label() { return getLabel(k); })
 * so they resolve at render time, not at module-import time.
 */
const STORAGE_KEY = 'terminologyOverrides';

let overrides = {};
try {
	const cached = localStorage.getItem(STORAGE_KEY);
	if (cached) overrides = JSON.parse(cached) || {};
} catch {
	overrides = {};
}

const listeners = new Set();

export const getLabel = (key) => {
	const value = overrides[key] !== undefined && overrides[key] !== '' ? overrides[key] : BASE_LABELS[key];
	return value !== undefined ? value : key;
};

export const getOverrides = () => ({ ...overrides });

/**
 * Nav tab labels come from the ObjectTab collection (DB). Only an explicit
 * terminology override beats the stored tab label; the base dictionary does not,
 * so deployments with custom ObjectTab labels keep them.
 */
export const getNavLabel = (schema, fallback) => {
	const key = NAV_LABEL_KEYS[schema];
	const override = key ? overrides[key] : undefined;
	return override !== undefined && override !== '' ? override : fallback;
};

export const setOverrides = (next) => {
	overrides = next && typeof next === 'object' ? next : {};
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(overrides));
	} catch {
		// storage unavailable (private mode/quota): labels still work for this session
	}
	listeners.forEach((listener) => listener());
};

export const subscribeToLabels = (listener) => {
	listeners.add(listener);
	return () => listeners.delete(listener);
};
